import React, { useEffect, useState } from 'react';
import { applyActionCode, onAuthStateChanged } from 'firebase/auth';
import { doc, updateDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../../firebase';
import { useTranslatedText } from '../i18n/useTranslatedText.js';
import './Auth.css';

const EmailVerification = () => {
  const navigate = useNavigate();
  const [verificationStatus, setVerificationStatus] = useState('checking');
  const titleText = useTranslatedText('E-posta Doğrulama');
  const checkingText = useTranslatedText('E-posta doğrulaması kontrol ediliyor...');
  const verifiedText = useTranslatedText('E-posta doğrulandı. Profile yönlendiriliyorsunuz...');
  const alreadyVerifiedText = useTranslatedText('E-posta zaten doğrulanmış. Yönlendiriliyorsunuz...');
  const notVerifiedText = useTranslatedText('E-posta henüz doğrulanmamış. Lütfen gelen kutunuzu kontrol edin.');
  const noUserText = useTranslatedText('Önce giriş yapmanız gerekiyor. Yönlendiriliyorsunuz...');
  const failedText = useTranslatedText('Doğrulama başarısız oldu. Lütfen tekrar deneyin.');

  const syncVerification = async (userId) => {
    await updateDoc(doc(db, 'users', userId), { emailVerified: true });
  };

  useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(window.location.search);
      const oobCode = params.get('oobCode');
      const mode = params.get('mode');

      if (oobCode && mode === 'verifyEmail') {
        try {
          await applyActionCode(auth, oobCode);
          if (auth.currentUser) {
            await auth.currentUser.reload();
            await auth.currentUser.getIdToken(true);
            await syncVerification(auth.currentUser.uid);
          }
          setVerificationStatus('verified');
          setTimeout(() => navigate('/profil'), 1800);
        } catch {
          setVerificationStatus('error');
        }
        return;
      }

      const unsubscribe = onAuthStateChanged(auth, async (user) => {
        if (!user) {
          setVerificationStatus('no-user');
          setTimeout(() => navigate('/giriş-yap'), 1800);
          return;
        }
        await user.reload();
        if (user.emailVerified) {
          await user.getIdToken(true);
          await syncVerification(user.uid);
          setVerificationStatus('already-verified');
          setTimeout(() => navigate('/profil'), 1800);
        } else {
          setVerificationStatus('not-verified');
        }
      });

      return () => unsubscribe();
    };

    run();
  }, [navigate]);

  const statusMessage = (() => {
    switch (verificationStatus) {
      case 'checking':
        return checkingText;
      case 'verified':
        return verifiedText;
      case 'already-verified':
        return alreadyVerifiedText;
      case 'not-verified':
        return notVerifiedText;
      case 'no-user':
        return noUserText;
      default:
        return failedText;
    }
  })();

  return (
    <div className="auth-container">
      <h2>{titleText}</h2>
      <p className={`verification-message ${verificationStatus}`}>{statusMessage}</p>
    </div>
  );
};

export default EmailVerification;
